
<template>
  <section class="pm-montage" id="montage">
    <div class="container">

      <div class="pm-heading">
        <span class="pm-eyebrow">VOTRE MONTAGE, VOTRE CHOIX</span>

        <h2>
          Un montage simple et
          <span>partout en France</span>
        </h2>

        <p>
          Découvrez les solutions de montage et choisissez
          celle qui correspond le mieux à vos besoins.
        </p>
      </div>

      <div class="pm-grid">
        <article
          v-for="option in options"
          :key="option.id"
          class="pm-card"
        >
          <div class="pm-visual">
            <img
              :src="option.image"
              :alt="option.alt"
              loading="lazy"
              @error="handleImageError($event)"
            />
            <span class="pm-image-tag">{{ option.tag }}</span>
          </div>

          <div class="pm-content">
            <div class="pm-title-row">
              <span class="pm-title-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    v-if="option.id === 'garage'"
                    d="M3 10V5l9-3 9 3v5M4 10h16v10H4zM8 20v-7h8v7"
                  />
                  <template v-else>
                    <path d="M2 7h12v10H2zM14 10h4l4 4v3h-8z"/>
                    <circle cx="6" cy="18" r="2"/>
                    <circle cx="18" cy="18" r="2"/>
                  </template>
                </svg>
              </span>

              <h3>{{ option.title }}</h3>
            </div>

            <p class="pm-description">
              {{ option.description }}
            </p>

            <ul>
              <li
                v-for="(benefit, i) in option.benefits"
                :key="i"
              >
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="m5 12 4 4L19 6"/>
                </svg>
                {{ benefit }}
              </li>
            </ul>

            <router-link
              :to="option.to"
              class="pm-button"
            >
              {{ option.button }}

              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12h16m-7-7 7 7-7 7"/>
              </svg>
            </router-link>
          </div>
        </article>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "MontageOptions",

  data() {
    return {
      options: [
        {
          id: "garage",
          title: "En garage partenaire",
          tag: "MONTAGE EN CENTRE",
          image: "/assets/images/montage/garage.jpg",
          alt: "Technicien effectuant le montage d'un pneu en garage",
          description:
            "Une solution pratique pour faire monter vos pneus par un professionnel.",
          benefits: [
            "Choisissez un garage selon votre localisation",
            "Profitez d'un accompagnement professionnel",
            "Organisez votre intervention simplement",
          ],
          button: "Nous contacter",
          to: "/contact",
        },
        {
          id: "mobile",
          title: "Montage à domicile",
          tag: "SERVICE MOBILE",
          image: "/assets/images/montage/mobile.jpg",
          alt: "Véhicule atelier destiné au montage de pneus",
          description:
            "Une alternative flexible pour faire remplacer vos pneus sur le lieu de votre choix.",
          benefits: [
            "Intervention à domicile ou sur votre lieu de travail",
            "Solution pensée pour gagner du temps",
            "Disponibilité à confirmer selon votre secteur",
          ],
          button: "En savoir plus",
          to: "/contact",
        },
      ],
    };
  },

  methods: {
    handleImageError(event) {
      event.target.style.display = "none";
      event.target.parentElement.classList.add("pm-no-photo");
    },
  },
};
</script>

<style scoped>
.pm-montage {
  padding: 74px 0 58px;
  background: #f5f7f9;
  font-family: "Poppins", sans-serif;
}

.pm-heading {
  margin-bottom: 27px;
}

.pm-eyebrow {
  display: block;
  color: #ff7900;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 2px;
  margin-bottom: 9px;
}

.pm-heading h2 {
  margin: 0 0 8px;
  color: #191e23;
  font-size: clamp(26px, 2.7vw, 35px);
  line-height: 1.3;
  font-weight: 900;
  letter-spacing: -1px;
}

.pm-heading h2 span {
  color: #ff7900;
}

.pm-heading p {
  margin: 0;
  font-size: 13px;
  color: #7b8289;
  line-height: 1.8;
}

.pm-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.pm-card {
  display: grid;
  grid-template-columns: 43% minmax(0, 1fr);
  min-height: 268px;
  background: #fff;
  border: 1px solid #e8ecef;
  border-radius: 13px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(15, 23, 35, .045);
  transition: transform .25s, box-shadow .25s;
}

.pm-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 15px 36px rgba(15, 23, 35, .1);
}

.pm-visual {
  position: relative;
  background: linear-gradient(145deg, #2b333a, #12171c);
  min-height: 240px;
  overflow: hidden;
}

.pm-visual img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transition: transform .4s;
}

.pm-card:hover .pm-visual img {
  transform: scale(1.06);
}

.pm-visual::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    0deg, rgba(0,0,0,.45), transparent 45%
  );
  pointer-events: none;
}

.pm-image-tag {
  position: absolute;
  left: 13px;
  bottom: 15px;
  color: white;
  z-index: 1;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1.1px;
}

.pm-content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 21px 21px 20px;
}

.pm-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pm-title-icon {
  color: #ff7900;
  flex-shrink: 0;
}

.pm-title-icon svg {
  width: 27px;
  height: 27px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pm-title-row h3 {
  color: #20262b;
  font-size: 14px;
  font-weight: 850;
  line-height: 1.4;
  margin: 0;
}

.pm-description {
  color: #78818a;
  font-size: 11px;
  line-height: 1.8;
  margin: 0 0 12px;
}

.pm-content ul {
  list-style: none;
  margin: 0 0 19px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.pm-content li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #535c65;
  font-size: 11px;
  line-height: 1.5;
}

.pm-content li svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  stroke: #ff7900;
  stroke-width: 2.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  margin-top: 1px;
}

.pm-button {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  margin-top: auto;
  color: #f07300;
  border: 1px solid #ff7900;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 11px;
  font-weight: 800;
  text-decoration: none !important;
  transition: background .2s, color .2s;
}

.pm-button:hover {
  background: #ff7900;
  color: white;
}

.pm-button svg {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

@media (max-width: 1199px) {
  .pm-card {
    grid-template-columns: 1fr;
  }

  .pm-visual {
    height: 200px;
    min-height: 200px;
  }
}

@media (max-width: 767px) {
  .pm-montage {
    padding: 55px 0 45px;
  }

  .pm-grid {
    grid-template-columns: 1fr;
  }

  .pm-card {
    grid-template-columns: 40% minmax(0, 1fr);
    min-height: 240px;
  }

  .pm-visual {
    height: auto;
    min-height: 240px;
  }
}

@media (max-width: 480px) {
  .pm-card {
    grid-template-columns: 1fr;
  }

  .pm-visual {
    height: 205px;
    min-height: 205px;
  }

  .pm-content {
    padding: 21px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pm-card,
  .pm-visual img {
    transition: none;
  }
}
</style>
